/**
 * Uppercases the first non-whitespace character; leaves the rest of the string unchanged.
 */
export function capitalizeLeadingCharacter(text: string): string {
  const match = text.match(/^(\s*)(\S)(.*)$/s);
  if (!match) return text;
  return `${match[1]}${match[2].toUpperCase()}${match[3]}`;
}
